// Which partner store the cart is checking out in. WhiteLabelContext's
// partnerSlug covers partner subdomains AND custom domains (edge-injected
// meta tag); the hostname parse is kept as a fallback for renders outside
// the provider.
export function resolveStorePartnerSlug({
  whiteLabelSlug = null,
  hostname = "",
  partnerDomain = "procertcompliance.com",
} = {}) {
  if (whiteLabelSlug) return whiteLabelSlug;
  const host = String(hostname).toLowerCase();
  const domain = String(partnerDomain).toLowerCase();
  if (!host.endsWith(`.${domain}`) || host === `www.${domain}`) return null;
  const slug = host.slice(0, -(domain.length + 1));
  return slug && !slug.includes(".") ? slug : null;
}
